import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import Image from '../../atoms/Image';
import { GatsbyImagePropType, MenuItemVariationPropType } from '../../services/proptypes';
import SpecialPrice from '../Special/components/SpecialPriceVariation';
import './SpecialImageCaption.css';
var SpecialImageCaption = function SpecialImageCaption(props) {
  var gatsbyImage = props.gatsbyImage,
    image = props.image,
    name = props.name,
    description = props.description,
    variations = props.variations,
    category = props.category,
    precision = props.precision;
  return /*#__PURE__*/React.createElement("div", {
    className: "special-image-caption-container"
  }, /*#__PURE__*/React.createElement(Image, {
    src: !_isEmpty(gatsbyImage) ? gatsbyImage.childImageSharp : image,
    alt: name,
    background: true,
    className: "special-image-caption"
  }, /*#__PURE__*/React.createElement("div", {
    className: "special-image-caption-text-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "special-image-caption-caption"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "special-image-caption-title"
  }, name), category && /*#__PURE__*/React.createElement("h4", {
    className: "special-image-caption-title-category"
  }, category), /*#__PURE__*/React.createElement("span", {
    className: "special-image-caption-description"
  }, description), /*#__PURE__*/React.createElement(SpecialPrice, {
    variations: variations,
    precision: precision
  })))));
};
SpecialImageCaption.defaultProps = {
  gatsbyImage: {},
  category: null,
  precision: 2
};
export default SpecialImageCaption;